import { render, staticRenderFns } from "./newTicketModal.vue?vue&type=template&id=67b1e1bd"
import script from "./newTicketModal.vue?vue&type=script&lang=js"
export * from "./newTicketModal.vue?vue&type=script&lang=js"
import style0 from "./newTicketModal.vue?vue&type=style&index=0&id=67b1e1bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports